///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import types from "./types";
import { zonedTimeToUtc } from "date-fns-tz";
import { parseISO } from "date-fns";

const getSpotLegsFromState = (numberOfLegs, legs, isDoubles, trailerType) => {
  const spotLegs = [];
  const parsedTrailerType = parseInt(trailerType, 10);
  for (let i = 1; i <= numberOfLegs; i++) {
    const spotTrailers = [
      {
        trailerType: parsedTrailerType,
        trailerNumber: legs[i]?.trailer ?? "",
      },
    ];
    if (isDoubles) {
      spotTrailers.push({
        trailerType: parsedTrailerType,
        trailerNumber: legs[i]?.trailer2 ?? "",
      });
    }
    spotLegs.push({
      routeCode: legs[i]?.routeCode ?? "",
      spotTrailers: spotTrailers,
    });
  }
  return spotLegs;
};
export const mapStateToSpotLegs = (adHoc) => {
  const doubles = adHoc.requirements.includes(2);
  const parsedSchedDeparture = zonedTimeToUtc(
    parseISO(adHoc.scheduledDeparture),
    adHoc.movementOrigin?.timeZoneName
  ).toISOString();
  const parsedSchedArrival = zonedTimeToUtc(
    parseISO(adHoc.scheduledArrival),
    adHoc.movementDestination?.timeZoneName
  ).toISOString();

  return {
    creationType: 1, //AdHoc
    status: 1, //Uncovered
    driverType: adHoc.driverType,
    serviceLevel:
      types.serviceLevels.findIndex((val) => val.code === adHoc.serviceLevel) +
      1,
    loadOriginFacilityId: adHoc.loadOrigin.id,
    loadDestinationFacilityId: adHoc.loadDestination.id,
    movementOriginFacilityId: adHoc.movementOrigin.id,
    movementDestinationFacilityId: adHoc.movementDestination.id,
    scheduledDepartureDateTimeUTC: parsedSchedDeparture,
    scheduledArrivalDateTimeUTC: parsedSchedArrival,
    doubles: adHoc.requirements.includes(2),
    uiia: adHoc.requirements.includes(1),
    loadOriginSortType: adHoc.loadOriginSort,
    loadDestinationSortType: adHoc.loadDestinationSort,
    spotLegs: getSpotLegsFromState(
      adHoc.numberOfLegs,
      adHoc.legs,
      doubles,
      adHoc.trailerType
    ),
  };
};

export const getValidationErrorsFromState = (adHoc) => {
  return {
    loadOrigin: { valid: !!adHoc.loadOrigin && !!adHoc.loadOrigin.id },
    loadOriginSort: { valid: !!adHoc.loadOriginSort },
    loadDestination: {
      valid: !!adHoc.loadDestination && !!adHoc.loadDestination.id,
    },
    loadDestinationSort: { valid: !!adHoc.loadDestinationSort },
    movementOrigin: {
      valid: !!adHoc.movementOrigin && !!adHoc.movementOrigin.id,
    },
    movementDestination: {
      valid: !!adHoc.movementDestination && !!adHoc.movementDestination.id,
    },
    driverType: { valid: !!adHoc.driverType },
    serviceLevel: { valid: !!adHoc.serviceLevel },
    trailerType: { valid: !!adHoc.trailerType },
    numberOfLegs: {
      valid:
        !!adHoc.numberOfLegs &&
        adHoc.numberOfLegs > 0 &&
        adHoc.numberOfLegs <= 10,
    },
    scheduledDeparture: { valid: adHoc.scheduledDeparture !== null },
    scheduledArrival: { valid: adHoc.scheduledArrival !== null },
  };
};
